import { EditorState, Transaction } from "prosemirror-state";
import { Node } from "prosemirror-model";
import { getTopLevelNodes } from "./GetNodes";
import { isAnyMarkActive } from "./InlineCommands";

function clearBlockFormattingFactory(alsoClearInline: boolean) {
	return function clearBlockFormatting(state: EditorState, dispatch?: (tx: Transaction) => void) {
		const blocksToClear = getTopLevelNodes(state).some(
			o =>
				o.node.type !== state.schema.nodes.paragraph ||
				o.node.attrs.align !== "left" ||
				o.node.attrs.indent !== 0
		);
		const marksToClear = alsoClearInline && isAnyMarkActive(state);
		const workToDo = blocksToClear || marksToClear;
		if (!dispatch || !workToDo) {
			return workToDo;
		}

		const { tr } = state;
		const { from, to } = tr.selection;

		if (marksToClear) {
			tr.setStoredMarks([]).removeMark(from, to);
		}

		tr.doc.nodesBetween(from, to, (node, pos) => {
			if (
				node.type === state.schema.nodes.paragraph ||
				node.type === state.schema.nodes.heading
			) {
				tr.setNodeMarkup(tr.mapping.map(pos), state.schema.nodes.paragraph);
			} else if (
				node.type === state.schema.nodes.ordered_list ||
				node.type === state.schema.nodes.unordered_list
			) {
				const pchilds: Node[] = [];
				tr.doc.nodesBetween(
					tr.mapping.map(pos),
					tr.mapping.map(pos) + node.nodeSize,
					(n, p) => {
						if (n.type === state.schema.nodes.paragraph) {
							pchilds.push(n);
							return false;
						} else {
							return true;
						}
					}
				);
				tr.replaceWith(tr.mapping.map(pos), tr.mapping.map(pos) + node.nodeSize, pchilds);
			}

			return false;
		});

		dispatch(tr);
		return true;
	};
}

export const clearBlockFormatting = clearBlockFormattingFactory(false);
export const clearAllFormatting = clearBlockFormattingFactory(true);
